import { getCommonAxiosCommon } from 'app/helpers/MiscUtils';
import { NgAPIResponse, Sponsor } from 'app/types';
import axios from 'axios';
import { config } from 'config';

export class SponsorService {
    private baseUrl = `${config.vjfpNGRestAPI}/organizations/sponsors`;

    async createSponsor (sponsorData: Partial<Sponsor>): Promise<Sponsor> {
      const result = await axios.post<NgAPIResponse<Sponsor>>(
        this.baseUrl,
        sponsorData,
        await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to create sponsor');
      }

      return result.data.data;
    }

    async getAllSponsors (limit?: number, cursor?: string): Promise<{ sponsors: Sponsor[], nextCursor?: string }> {
      const params = new URLSearchParams();
      if (limit) {
        params.append('limit', limit.toString());
      }
      if (cursor) {
        params.append('cursor', cursor);
      }

      const url = `${this.baseUrl}${params.toString() ? '?' + params.toString() : ''}`;
      const result = await axios.get<NgAPIResponse<{ items: Sponsor[], nextCursor?: string }>>(
        url,
        await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to get sponsors');
      }

      return {
        sponsors: result.data.data.items,
        nextCursor: result.data.data.nextCursor
      };
    }

    async getSponsorById (sponsorId: string): Promise<Sponsor> {
      const result = await axios.get<NgAPIResponse<Sponsor>>(
            `${this.baseUrl}/${sponsorId}`,
            await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to get sponsor');
      }

      return result.data.data;
    }

    async updateSponsor (sponsorId: string, sponsorData: Partial<Sponsor>): Promise<Sponsor> {
      const result = await axios.put<NgAPIResponse<Sponsor>>(
            `${this.baseUrl}/${sponsorId}`,
            sponsorData,
            await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to update sponsor');
      }

      return result.data.data;
    }

    async deleteSponsor (sponsorId: string): Promise<void> {
      const result = await axios.delete<NgAPIResponse<void>>(
            `${this.baseUrl}/${sponsorId}`,
            await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to delete sponsor');
      }
    }

    async getSubdomainStatus (): Promise<string> {
      const result = await axios.get<NgAPIResponse<{ domainStatus: string }>>(
        `${this.baseUrl}/domain-status`,
        await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to get subdomain status');
      }

      return result.data.data.domainStatus;
    }

    async deleteSubdomainAssociation (sponsorId: string): Promise<void> {
      const result = await axios.delete<NgAPIResponse<void>>(
        `${this.baseUrl}/${sponsorId}/subdomain`,
        await getCommonAxiosCommon()
      );

      if (!result.data?.isSuccess) {
        console.error(result.data.errors);
        throw new Error('Failed to delete subdomain association');
      } else {
        console.log('Subdomain association deleted successfully');
      }
    }
}
